import constants from '../constants';
import type { AppThunkVoid } from '../types';

export const setHoverId = (id: string | null): AppThunkVoid => {
  return (dispatch) => {
    dispatch({
      type: constants.SET_HOVER_ID,
      payload: id,
    });
  };
};

export const setActiveId = (id: string | null): AppThunkVoid => {
  return (dispatch) => {
    dispatch({
      type: constants.SET_ACTIVE_ID,
      payload: id,
    });
  };
};
